var section = document.getElementsByClassName("blog-search__item-container");
var special_blog = document.getElementsByClassName("blog-search__item-container__special");
var big_blog = document.getElementsByClassName("blog-search__item-container__special--big");
var small_blog = document.getElementsByClassName("blog-search__item-container__special--small");
var show_more_button = document.getElementsByClassName("blog-search__item-list--button");
let all_cards = document.getElementsByClassName("blog-search__item-list__recipe");
let blog_cards_shown = document.getElementsByClassName("blog-search__item-list__recipe--shown");
var blog_cards_hiden = document.getElementsByClassName("blog-search__item-list__recipe--hiden");
var blog_card_tags = "collection-blogs-wrapper__tag";
var url_variable_name = 'tag';

function card_structure(){
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);
    let tag = urlParams.get(url_variable_name)
    if(tag !== null){
        tag = tag.replace(/-/g, " ")
        tag = tag.replace(/[^A-Za-z0-9]/g,"");
        applyFilter(tag);
    }
    hide_extra_cards();
    var blog_cards;
    blog_cards = document.getElementsByClassName("blog-search__item-list__recipe blog-search__item-list__recipe--shown");
    let complete_card = blog_cards[0].getElementsByClassName('collection-blogs-wrapper');
    if(complete_card[0].classList.contains('collection-blogs-wrapper--complete') == false){
        complete_card[0].classList.add("collection-blogs-wrapper--complete");
        complete_card[0].classList.remove("collection-blogs-wrapper--incomplete");
    }

    blog_cards[0].classList.add("blog-search__item-list__recipe--big");
    big_blog[0].appendChild(blog_cards[0]);

    blog_cards[1].classList.add("blog-search__item-list__recipe--small");
    small_blog[0].appendChild(blog_cards[1]);

    blog_cards[2].classList.add("blog-search__item-list__recipe--small");
    small_blog[0].appendChild(blog_cards[2]);
    if(blog_cards_hiden.length > 0){
        show_more_button[0].style.display = 'flex';
    }else{
        show_more_button[0].style.display = 'none';
    }
    card_distribution();
}

function applyFilter(tag){
    let articles = document.getElementsByClassName("blog-search__item-list__recipe");
    var tags, swap, tag_name;
    tag = tag.toLowerCase();
    Array.from(articles).forEach(article => {
        tags = article.getElementsByClassName(blog_card_tags);
        swap = false;
        Array.from(tags).forEach(element => {
            tag_name = element.innerText;
            tag_name = tag_name.replace(/-/g," ");
            tag_name = tag_name.replace(/[^A-Za-z0-9]/g,"");
            tag_name = tag_name.toLowerCase();
            if( tag_name.includes(tag)){
                swap = true;
            }
        });
        if( swap === false ){
            article.remove();
        }
    });
}

function hide_extra_cards(){
    let articles = document.getElementsByClassName("blog-search__item-list__recipe");
    let counter = 1;
    let swap = false;
    Array.from(articles).forEach(article => {
        if(counter > 9 ){
            article.classList.add('blog-search__item-list__recipe--hiden');
            article.classList.remove('blog-search__item-list__recipe--shown');
            swap = true;
        }
        counter++;
    });
    let button = document.getElementsByClassName('blog-search__item-list--button')
    if(swap){
        button[0].style.display = 'flex';
    }else{
        button[0].style.display = 'none';
    }
}

function card_distribution(){
    var incomplete_card_assistant;
    var incomplete_card_pivot = 0;
    if( screen.width <= 880){
        Array.from(blog_cards_shown).forEach(element => {
            if(element.classList.contains('blog-search__item-list__recipe--big') == false){
                if(incomplete_card_pivot % 2 == 0 ){
                    incomplete_card_auxiliar = element.getElementsByClassName("collection-blogs-wrapper")[0];
                    incomplete_card_auxiliar.classList.add('collection-blogs-wrapper--incomplete--reverse');
                }
                incomplete_card_pivot++;
            }
        });
    }
}

function show_more_recipes(){
    let iterator_length;
    if(blog_cards_hiden.length >= 6){
        iterator_length = 6;
    }else{
        iterator_length = blog_cards_hiden.length;
        show_more_button[0].style.display = 'none';
    }
    for( var iterator = 0; iterator < iterator_length; iterator++ ){
        if(blog_cards_hiden[0] != null){
            blog_cards_hiden[0].classList.add("blog-search__item-list__recipe--shown");
            blog_cards_hiden[0].classList.remove("blog-search__item-list__recipe--hiden");
        }
    }
    var clean_reverse = document.getElementsByClassName('collection-blogs-wrapper');
    Array.from(clean_reverse).forEach(element => {
        element.classList.remove('collection-blogs-wrapper--incomplete--reverse');
    });
    card_distribution();
}

function orderMethod(){
    let blog;
    let blog_value = [];
    if(this.value == 'alpha' || this.value == 'alpha_reverse'){
        for( var iterator = 0; iterator < all_cards.length; iterator++ ){
            blog = all_cards[iterator];
            blog_value.push(blog.getElementsByClassName("collection-blogs-wrapper__content__title")[0].getElementsByTagName("p")[0].innerText.toLowerCase());
        }
        blog_value.sort();
        hide_all_cards();
        if(this.value == 'alpha'){
            blog_value.reverse();
        }
        order_title_card(blog_value);
    }else{
        for( var iterator = 0; iterator < all_cards.length; iterator++ ){
            blog = all_cards[iterator];
            blog_value.push(blog.getElementsByClassName("collection-blogs-wrapper__content__date")[0].innerText);
        }
        blog_value.sort();
        hide_all_cards();
        if(this.value == 'newest'){
            blog_value.reverse();
        }
        order_date_card(blog_value);
    }
    card_distribution();
}

function hide_all_cards(){
    for(let iterator = 0 ; iterator < 3; iterator++){
        if(iterator == 0 ){
            let big_card = blog_cards_shown[iterator].getElementsByClassName("collection-blogs-wrapper");
            big_card[0].classList.remove("collection-blogs-wrapper--complete");
            big_card[0].classList.add("collection-blogs-wrapper--incomplete");
        }
        blog_cards_shown[0].classList.remove("blog-search__item-list__recipe--big");
        blog_cards_shown[0].classList.remove("blog-search__item-list__recipe--small");
        blog_cards_shown[0].classList.add("special-erase");
        section[0].appendChild(blog_cards_shown[0]);
        document.getElementsByClassName("special-erase")[0].classList.remove("blog-search__item-list__recipe--shown");
        document.getElementsByClassName("special-erase")[0].classList.add("blog-search__item-list__recipe--hiden");
    }
    for( var iterator = 0; iterator < blog_cards_shown.length; iterator++ ){
        blog_cards_shown[iterator].classList.add("blog-search__item-list__recipe--hiden");
        blog_cards_shown[iterator].classList.add("special-erase");
    }
    var erased_card = document.getElementsByClassName('special-erase');
    Array.from(erased_card).forEach(element => {
        element.classList.remove('blog-search__item-list__recipe--shown');
    });
    var erased_card = document.getElementsByClassName('blog-search__item-list__recipe');
    Array.from(erased_card).forEach(element => {
        element.classList.remove('special-erase');
    });
    var erased_reverse = document.getElementsByClassName('collection-blogs-wrapper--incomplete');
    Array.from(erased_reverse).forEach(element => {
        element.classList.remove('collection-blogs-wrapper--incomplete--reverse');
    });
}

function order_title_card(data){
    let comparison_name;
    for( var counter = 0; counter < data.length; counter++ ){
        for( var iterator = 0; iterator < all_cards.length; iterator++ ){
            comparison_name = all_cards[iterator].getElementsByClassName("collection-blogs-wrapper__content__title")[0].getElementsByTagName("p")[0].innerText;
            if(data[counter].trim().toLowerCase() === comparison_name.trim().toLowerCase()){
                sw = true;
                all_cards[iterator].classList.add("blog-search__item-list__recipe--shown");
                all_cards[iterator].classList.remove("blog-search__item-list__recipe--hiden");
                section[0].insertBefore(all_cards[iterator], section[0].children[0]);
                break;
            }
        }
    }
    section[0].insertBefore(special_blog[0], section[0].children[0]);
    card_structure();
}
function order_date_card(data){
    let comparison_name;
    for( var counter = 0; counter < data.length; counter++ ){
        var sw = false;
        for( var iterator = 0; iterator < all_cards.length; iterator++ ){
            comparison_name = all_cards[iterator].getElementsByClassName("collection-blogs-wrapper__content__date")[0].innerText;
            
            if(data[counter].trim().toLowerCase() == comparison_name.trim().toLowerCase()){
                sw = true;
                all_cards[iterator].classList.add("blog-search__item-list__recipe--shown");
                all_cards[iterator].classList.remove("blog-search__item-list__recipe--hiden");
                section[0].insertBefore(all_cards[iterator], section[0].children[0]);
                break;
            }
        }
    }
    section[0].insertBefore(special_blog[0], section[0].children[0]);
    card_structure();
}
